<form [formGroup]="form">
    <div class="row">
        <app-alert *ngIf="!isFormValid && showValidations" type="error" [message]="errorMessage"></app-alert>

        <div class="lifecycle-form-line">
            <app-input
                type="number"
                formControlName="partNumbersCount"
                labelAlign="top"
                tooltipText="{{'admin.tools.details.detailsPage.tooltips.partNumbersCount' | translate}}"
                [formControl]="form.controls.partNumbersCount"
                [showErrors]="showValidations"
                placeholder="{{'admin.tools.details.detailsPage.labels.partNumbersCount' | translate }}"
                label="{{'admin.tools.details.detailsPage.labels.partNumbersCount' | translate }}">
            </app-input>
        </div>

        <div class="lifecycle-form-line">
            <app-input
                type="number"
                formControlName="currentProductionCycles"
                labelAlign="top"
                tooltipText="{{'admin.tools.details.detailsPage.tooltips.toolCurrentProductionCycles' | translate}}"
                [formControl]="form.controls.currentProductionCycles"
                [showErrors]="showValidations"
                placeholder="{{'admin.tools.details.detailsPage.labels.currentProductionCycles' | translate }}"
                label="{{'admin.tools.details.detailsPage.labels.currentProductionCycles' | translate }}">
            </app-input>
        </div>

        <div class="lifecycle-form-line">
            <app-input-duration formControlName="currentProductionTime"
                                labelAlign="top"
                                [tooltipText]="'admin.tools.details.detailsPage.tooltips.toolCurrentProductionTime' | translate"
                                [formControl]="form.controls.currentProductionTime"
                                [showErrors]="showValidations"
                                (inputChange)="currentProductionTimeChanged($event)"
                                placeholder="{{'admin.tools.details.detailsPage.labels.currentProductionTime' | translate }}"
                                label="{{'admin.tools.details.detailsPage.labels.currentProductionTime' | translate }}">
            </app-input-duration>
        </div>

        <div class="lifecycle-form-line">
            <app-input
                type="number"
                formControlName="toolRevisionPercent"
                labelAlign="top"
                [tooltipText]="'admin.tools.details.detailsPage.tooltips.revisionPercent' | translate"
                [formControl]="form.controls.toolRevisionPercent"
                [showErrors]="showValidations"
                placeholder="{{'admin.tools.details.detailsPage.labels.revisionPercent' | translate }}"
                label="{{'admin.tools.details.detailsPage.labels.revisionPercent' | translate }}">
            </app-input>
        </div>

        <div class="lifecycle-form-line">
            <app-input-datepicker formControlName="expirationDate"
                                  labelAlign="top"
                                  [formControl]="form.controls.expirationDate"
                                  [showErrors]="showValidations"
                                  [appendTo]="'body'"
                                  placeholder="{{'admin.tools.details.detailsPage.labels.toolExpirationDate' | translate }}"
                                  label="{{'admin.tools.details.detailsPage.labels.toolExpirationDate' | translate }}">
            </app-input-datepicker>
        </div>
    </div>
</form>
